import { render, staticRenderFns } from "./WelcomeVideo.vue?vue&type=template&id=60761925"
import script from "./WelcomeVideo.vue?vue&type=script&lang=js"
export * from "./WelcomeVideo.vue?vue&type=script&lang=js"
import style0 from "./WelcomeVideo.vue?vue&type=style&index=0&id=60761925&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports